import {
  Heading,
  Text,
  Box,
  Columns,
  Column,
  Actions,
  Stack,
  ButtonLink,
  TextLink,
} from 'braid-design-system';

import { ModuleTheme } from 'src/types';
import ImageContainer from 'src/views/shared/MediaContainers/ImageContainer';
import PageSection from 'src/views/shared/PageSection/PageSection';
import TrackingLink from 'src/views/shared/TrackingLink/TrackingLink';

export interface Props {
  id: string;
  title: string;
  text: string;
  imageSrc: string;
  imageText?: string;
  buttonLinkHref: string;
  buttonLinkEvent: string;
  buttonLinkText: string;
  linkHref?: string;
  linkEvent?: string;
  linkText?: string;
  theme?: ModuleTheme;
  reverse?: boolean;
}

const ImageContentSplit = ({
  id,
  title,
  text,
  imageSrc,
  imageText = '',
  buttonLinkHref,
  buttonLinkEvent,
  buttonLinkText,
  linkHref,
  linkEvent,
  linkText,
  theme = ModuleTheme.LIGHT,
  reverse = false,
}: Props) => (
  <PageSection id={id} theme={theme}>
    <Columns
      collapseBelow="tablet"
      space={['large', 'xlarge']}
      reverse={reverse}
    >
      <Column>
        <ImageContainer src={imageSrc} altText={imageText} ratio="4x3" />
      </Column>
      <Column>
        <Box
          height="full"
          display="flex"
          alignItems="center"
          paddingRight={['none', 'large']}
        >
          <Stack space="large">
            <Heading level="2">{title}</Heading>
            <Text size="large" tone="secondary">
              {text}
            </Text>
            <Actions>
              <TrackingLink
                renderAs={ButtonLink}
                href={buttonLinkHref}
                data-analytics={buttonLinkEvent}
                data-analytics-origin={id}
                data-test={`${id}-cta`}
                variant={theme === ModuleTheme.LIGHT ? 'ghost' : 'solid'}
              >
                {buttonLinkText}
              </TrackingLink>
              {linkHref ? (
                <Box
                  display="flex"
                  alignItems="center"
                  height="touchable"
                  paddingLeft={['none', 'small']}
                  justifyContent={['center', null]}
                >
                  <Text>
                    <TrackingLink
                      renderAs={TextLink}
                      href={linkHref}
                      data-analytics={linkEvent}
                      data-analytics-origin={id}
                      data-test={`${id}-secondary-link`}
                    >
                      {linkText}
                    </TrackingLink>
                  </Text>
                </Box>
              ) : null}
            </Actions>
          </Stack>
        </Box>
      </Column>
    </Columns>
  </PageSection>
);

export default ImageContentSplit;
